import { DateTime } from 'luxon';

import { DATE_FORMAT } from 'constants/dateFormats';

export const formatISODate = (date: string) => DateTime.fromISO(date).toFormat(DATE_FORMAT);
